import {useMutation} from "@tanstack/react-query";
import {deleteClaim} from "../services/ClaimService";

export function useClaimDelete() {
    return useMutation({
        mutationFn: ({claimType, claimValue}) => deleteClaim(claimType, claimValue),
    });
}
